// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-7UG","badges":"styles_badges__3w5_W"};